import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Sidebar from '@/components/Sidebar';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import InvoiceUploadPage from '@/pages/InvoiceUploadPage';
import InvoiceListPage from '@/pages/InvoiceListPage';
import InvoiceDetailPage from '@/pages/InvoiceDetailPage';
import ExtractionReviewPage from '@/pages/ExtractionReviewPage';
import ApprovalQueuePage from '@/pages/ApprovalQueuePage';
import CostAttributionPage from '@/pages/CostAttributionPage';
import MoleculeCostPage from '@/pages/MoleculeCostPage';
import AIGovernancePage from '@/pages/AIGovernancePage';
import CharterPartiesPage from '@/pages/CharterPartiesPage';
import MovementsPage from '@/pages/MovementsPage';
import VesselTrackingPage from '@/pages/VesselTrackingPage';
import DemurrageForecastPage from '@/pages/DemurrageForecastPage';
import BerthSchedulePage from '@/pages/BerthSchedulePage';
import ContractAnalyticsPage from '@/pages/ContractAnalyticsPage';
import EmissionsDashboardPage from '@/pages/EmissionsDashboardPage';
import AskMolecuAIPage from '@/pages/AskMolecuAIPage';
import DealAnalyzerPage from '@/pages/DealAnalyzerPage';
import DealComparisonPage from '@/pages/DealComparisonPage';
import ExecutiveDashboardPage from '@/pages/ExecutiveDashboardPage';
import ForecastingPage from '@/pages/ForecastingPage';
import BenchmarkingPage from '@/pages/BenchmarkingPage';

function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Sidebar />
      <main className="ml-56 min-h-screen transition-all duration-200">
        {children}
      </main>
    </div>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/invoices" element={<ProtectedRoute><AppLayout><InvoiceListPage /></AppLayout></ProtectedRoute>} />
      <Route path="/invoices/:id" element={<ProtectedRoute><AppLayout><InvoiceDetailPage /></AppLayout></ProtectedRoute>} />
      <Route path="/upload" element={<ProtectedRoute><AppLayout><InvoiceUploadPage /></AppLayout></ProtectedRoute>} />
      <Route path="/extraction-review" element={<ProtectedRoute><AppLayout><ExtractionReviewPage /></AppLayout></ProtectedRoute>} />
      <Route path="/approvals" element={<ProtectedRoute><AppLayout><ApprovalQueuePage /></AppLayout></ProtectedRoute>} />
      <Route path="/charter-parties" element={<ProtectedRoute><AppLayout><CharterPartiesPage /></AppLayout></ProtectedRoute>} />
      <Route path="/movements" element={<ProtectedRoute><AppLayout><MovementsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/cost-attribution" element={<ProtectedRoute><AppLayout><CostAttributionPage /></AppLayout></ProtectedRoute>} />
      <Route path="/molecule-cost" element={<ProtectedRoute><AppLayout><MoleculeCostPage /></AppLayout></ProtectedRoute>} />
      <Route path="/vessel-tracking" element={<ProtectedRoute><AppLayout><VesselTrackingPage /></AppLayout></ProtectedRoute>} />
      <Route path="/demurrage-forecast" element={<ProtectedRoute><AppLayout><DemurrageForecastPage /></AppLayout></ProtectedRoute>} />
      <Route path="/berth-schedule" element={<ProtectedRoute><AppLayout><BerthSchedulePage /></AppLayout></ProtectedRoute>} />
      <Route path="/contracts" element={<ProtectedRoute><AppLayout><ContractAnalyticsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/emissions" element={<ProtectedRoute><AppLayout><EmissionsDashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/deal-analyzer" element={<ProtectedRoute><AppLayout><DealAnalyzerPage /></AppLayout></ProtectedRoute>} />
      <Route path="/deal-comparison" element={<ProtectedRoute><AppLayout><DealComparisonPage /></AppLayout></ProtectedRoute>} />
      <Route path="/ask" element={<ProtectedRoute><AppLayout><AskMolecuAIPage /></AppLayout></ProtectedRoute>} />
      <Route path="/executive" element={<ProtectedRoute><AppLayout><ExecutiveDashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/forecasting" element={<ProtectedRoute><AppLayout><ForecastingPage /></AppLayout></ProtectedRoute>} />
      <Route path="/benchmarking" element={<ProtectedRoute><AppLayout><BenchmarkingPage /></AppLayout></ProtectedRoute>} />
      <Route path="/governance" element={<ProtectedRoute><AppLayout><AIGovernancePage /></AppLayout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
